const STORAGE_KEY = 'agridbot'

// The in-house assistant is enabled by default. Visiting any dashboard URL
// with ?agridbot=false switches to Chatbase (persisted in localStorage so it
// survives SPA navigation and refreshes); ?agridbot=true switches it back.
// The Chatbase loader in index.html does the same check and skips injection
// unless the flag is explicitly false, so only one bot is ever visible at a
// time.
export const syncAgridBotFlagFromUrl = (): void => {
    try {
        const param = new URLSearchParams(window.location.search).get(STORAGE_KEY)
        if (param === 'true' || param === 'false') localStorage.setItem(STORAGE_KEY, param)
    } catch {
        // localStorage unavailable: stay on the default (Agrid bot)
    }
}

export const isAgridBotEnabled = (): boolean => {
    let param: string | null
    try {
        param = new URLSearchParams(window.location.search).get(STORAGE_KEY)
    } catch {
        return true
    }

    try {
        syncAgridBotFlagFromUrl()
        return localStorage.getItem(STORAGE_KEY) !== 'false'
    } catch {
        return param !== 'false'
    }
}
